import { isEmpty } from 'lodash-es';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Groups } from '@/modules/groups';
import { Tag, Text } from '@/modules/ui';
import { Whitelist } from '@/modules/whitelist';
import { hasReadPermission } from '@/utilities/permission';
import { isEmptyOrUndefined } from '@/utilities/string';

import { useSecretDetailContext } from '../SecretDetail/SecretDetailProvider';
import { SecretFieldSection } from '../SecretFieldSection';
import { SecretFile } from '../SecretFile';
import { SecretSection } from '../SecretSection';
import { EmptyContentGuard } from './EmptyContentGuard';
import * as felaRules from './SecretDetailSections.rules';
import { SecretFieldSectionsByType } from './SecretFieldSectionsByType';

export const SecretDetailSections = () => {
    const { css } = useFela();

    const secret = useSecretDetailContext();

    const { id, type, tags, file, note, groups, whitelistUsers, userPermissions } = secret;

    const hasRead = hasReadPermission(userPermissions);

    return (
        <div className={css(felaRules.container)}>
            <SecretSection title={`secret.type.${type}`}>
                <SecretFieldSectionsByType secret={secret} />
            </SecretSection>

            <SecretSection title='secret.sections.details.title'>
                <EmptyContentGuard>
                    {!isEmpty(tags) && (
                        <SecretFieldSection heading={<FormattedMessage id='secret.tags' />}>
                            <div className={css(felaRules.tags)}>
                                {tags?.map(tag => (
                                    <Tag key={tag}>{tag}</Tag>
                                ))}
                            </div>
                        </SecretFieldSection>
                    )}
                    {file && hasRead && (
                        <SecretFieldSection heading={<FormattedMessage id='secret.file' />}>
                            <SecretFile file={file} />
                        </SecretFieldSection>
                    )}
                    {!isEmptyOrUndefined(note) && hasRead && (
                        <SecretFieldSection heading={<FormattedMessage id='secret.note' />}>
                            <Text preserveNewLines>{note}</Text>
                        </SecretFieldSection>
                    )}
                </EmptyContentGuard>
            </SecretSection>

            <SecretSection title='secret.sections.permissions.title' customStyle={felaRules.rightColumn}>
                <EmptyContentGuard message='secret.sections.permissions.empty'>
                    {!isEmpty(groups) && (
                        <SecretFieldSection heading={<FormattedMessage id='secret.groups' />}>
                            <Groups groups={groups} />
                        </SecretFieldSection>
                    )}
                    {!isEmpty(whitelistUsers) && (
                        <SecretFieldSection heading={<FormattedMessage id='secret.whitelistUsers' />}>
                            <Whitelist key={id} whitelist={whitelistUsers} />
                        </SecretFieldSection>
                    )}
                </EmptyContentGuard>
            </SecretSection>
        </div>
    );
};
